import axios, { AxiosResponse } from 'axios'
import qs from 'qs'
import { getBindId } from '../components/editor/tools'
import { Toast } from 'antd-mobile'
import { getEntry } from '../util/tools'

let saveTimer: null | NodeJS.Timeout = null

var msgpack = require('msgpack-lite')

const {
  token: _t,
  env,
  identity,
  flutter,
} = qs.parse(window.location.search.substr(1)) as {
  token: string
  env: 'release' | 'prod' | 'develop'
  identity: string
  flutter?: string
}

const token =
  _t ||
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE2MTYwMzUwODcsImlhdCI6MTYxMzYxMjE1OSwiaXNzIjoiKi5mbHllbGUubmV0IiwiVXNlcklEIjoiNTUxNDQwODMxNDgwMDE3IiwiVG9rZW4iOiIiLCJQbGF0Zm9ybSI6IndlY2hhdCIsIkNsaWVudFZlcnNpb24iOiJ3ZWNoYXQtbXAgMS4wLjAifQ.OG37q_a-cNZOUJV3IdD4pfgeGcQAuQa3UUMfpsemp-M'

const envDict = {
  release: 'api-test.nm10086.p.flyele.vip',
  prod: 'api.flyele.nm135.cn',
  develop: 'api-test.nm10086.p.flyele.vip',
}

const baseURL =
  process.env.NODE_ENV === 'development'
    ? 'https://api-test.flyele.vip'
    : `https://${envDict[env]}`

const http = axios.create({
  baseURL,
  headers: {
    Authorization: token,
  },
})

http.interceptors.response.use(
  (res: AxiosResponse) => {
    return res
  },
  (err) => {
    try {
      const {
        response: { status },
      } = err

      switch (status) {
        case 401:
          if (flutter) {
            window.location =
              `js://webview?trigger=invalid_token` as unknown as Location
          } else {
            wx.miniProgram.navigateBack()
          }

          break
        default:
          break
      }
    } catch (e) {
      return Promise.reject(err)
    }

    return Promise.reject(err)
  }
)

identity && window.localStorage.setItem('identity', identity)

function init() {
  if (flutter) {
    var source = new EventSource(
      `${baseURL}/intime/stream?identity=${
        identity || window.localStorage.getItem('identity')
      }`
    )

    source.onerror = () => {
      console.error('sse 链接出错')
    }

    source.onopen = () => {
      console.log('sse 链接成功')
    }

    source.addEventListener('image_violate', (event) => {
      const { data: d } = event as unknown as { data: string }

      const { code, file_id } = JSON.parse(d)

      console.log('SSE message received:', file_id)

      if (code === 43) {
        document
          .querySelectorAll('.blot-uploaded.blot-common_img')
          .forEach((node) => {
            const dom = node as HTMLLinkElement
            if (dom.getAttribute('data-file') === file_id) {
              console.log('in delete pic')
              dom.style.backgroundImage =
                'url(./images/icon-file/icon-file-error.png)'
            }
          })
      }
    })

    source.onmessage = function (event) {
      console.debug('WebSocket message received:', event)
      const { data } = event

      const reader = new FileReader()
      reader.readAsArrayBuffer(data)
      reader.onload = (e) => {
        const { result } = e.srcElement as any
        const { co, file_id } = msgpack.decode(new Uint8Array(result))
        console.log(msgpack.decode(new Uint8Array(result)))
        if (co === 43) {
          console.log(file_id)
          document
            .querySelectorAll('.blot-uploaded.blot-common_img')
            .forEach((node) => {
              const dom = node as HTMLLinkElement
              console.log('domdom', dom, dom.getAttribute('data-file'))
              if (dom.getAttribute('data-file') === file_id) {
                console.log('ininini')
                dom.style.backgroundImage =
                  'url(./images/icon-file/icon-file-error.png)'
              }
            })
        }
      }
    }
    return
  }

  const socket = new WebSocket(
    `wss://${
      process.env.NODE_ENV === 'development'
        ? 'api-test.flyele.vip'
        : envDict[env]
    }/intime/ws?token=${token}`
  )

  socket.onopen = (res) => {
    console.log('socket ok', res)
    socket.send('hello')
  }

  socket.onerror = (res) => {
    console.log('socket error: ', res)
  }

  socket.onclose = (res) => {
    console.log('socket closed', res)
  }

  socket.onmessage = function (event) {
    console.log('WebSocket message received:', event)
    const reader = new FileReader()
    const { data } = event

    if (typeof data === 'string') return

    reader.readAsArrayBuffer(data)
    reader.onload = (e) => {
      const { result } = e.srcElement as any
      const { co, file_id } = msgpack.decode(new Uint8Array(result))
      console.log(msgpack.decode(new Uint8Array(result)))
      if (co === 43) {
        console.log(file_id)
        document
          .querySelectorAll('.blot-uploaded.blot-common_img')
          .forEach((node) => {
            const dom = node as HTMLLinkElement
            console.log('domdom', dom, dom.getAttribute('data-file'))
            if (dom.getAttribute('data-file') === file_id) {
              console.log('ininini')
              dom.style.backgroundImage =
                'url(./images/icon-file/icon-file-error.png)'
            }
          })
      }
    }
  }
}

init()

interface OssToken {
  callback: any
  dir: string
  policy: string
  accessid: string
  signature: string
  host: string
}

const upload = async (file: File, params: OssToken) => {
  // const { callback, dir, policy, accessid, signature, host } = params
  const formData = new FormData()
  // formData.append('callback', callback)
  // formData.append('key', dir + file.name)
  // formData.append('policy', policy)
  // formData.append('OSSAccessKeyId', accessid)
  // formData.append('signature', signature)
  // formData.append('success_action_status', '200')
  formData.append('file', file)

  return axios({
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
      'Cache-Control': 'max-age=604800',
    },
    url: `${baseURL}/storage/private/upload?ts=${Math.random()}`,
  })
}

const getToken = () => http.get<OssToken>('/disk/v2/storage/token')

export const getOnlineImgs = async (
  ids: string[],
  ossConfig = 'image/resize,w_200'
) => {
  const sIds = ids.join(',')
  let url = `/disk/v2/storages/batch?file_id=${sIds}`
  if (ossConfig) {
    url = url.concat(`&x-oss-process=${ossConfig}`)
  }
  return (await http.get(url)).data.data
}

export const getDraft = (ref_id: string) =>
  http.get(`/ui/v1/draft`, {
    params: {
      draft_type: 'summary',
      ref_id,
    },
  })

export const publish = (params: PublishParams) =>
  http.post('/ui/v1/comment', {
    ref_type: 'task',
    msg_type: 2, // 结论
    ...params,
  })

export const saveDraft = (params: PublishParams) =>
  http.post('/ui/v1/draft', {
    draft_type: 'summary',
    ...params,
  })

export const modifyDraft = (params: PublishParams, draftId: string) =>
  http.post(`/ui/v1/draft/${draftId}`, {
    ...params,
  })

export const saveDiary = async (params: DiaryParams) => {
  if (saveTimer) return

  let res = await new Promise((resolve) => {
    saveTimer = setTimeout(async () => {
      try {
        let res = (await http.post(`/record/v1/record`, params)).data.data
        saveTimer = null
        resolve(res)
      } catch (e) {
        saveTimer = null
        resolve(null)
      }
    }, 50)
  })

  return (res as { record_id: string }) || null
}

export const modifyDiary = async (params: DiaryParams, recordId: string) =>
  await http.post(`/record/v1/record/${recordId}`, params)

export const deleteDiary = (id: string) =>
  http.delete(`/record/v1/record/${id}`)

export const getDiaryAbstract = async (recordId: string) =>
  (await http.get(`/record/v1/record/${recordId}`)).data.data

export const getDiary = async (recordId: string) => {
  const arr = (
    await Promise.all([
      http.get(`/record/v1/record/${recordId}`),
      http.get(`/record/v1/record/${recordId}/content`),
    ])
  ).map((item) => item.data.data)

  window.localStorage.setItem('refTasks', JSON.stringify(arr[0].ref_tasks))

  return {
    title: arr[0].title as string,
    content: arr[1] as string,
    ref_tasks: arr[0].ref_tasks as string[],
    isNote: arr[0].record_type === 1,
    createTime: arr[0].create_at as number,
    updateTime: arr[0].update_at as number,
  }
}

export const uploadFile = async (res: InputCallbackResult) => {
  const { fileDict, curFileDict } = res
  try {
    const params = (await getToken()).data

    console.log('dictdict -->', fileDict, curFileDict)

    Object.values(curFileDict).forEach((item) => {
      const { file, tempId } = item
      upload(file, params)
        .then((res) => {
          // console.log('success', res.data.data.file_id)
          // upload success
          changeFileState(tempId, fileDict, res.data.data[0])
        })
        .catch((e) => {
          // upload fail
          console.log('upload file fail -->', e)
          changeFileState(tempId, fileDict)
        })
    })
  } catch (e) {
    alert('上传 token 获取失败')
    console.log('上传 token 获取失败', e)
    console.log(JSON.stringify(e))
    Object.values(curFileDict).forEach((item) => {
      const { tempId } = item
      // upload fail
      changeFileState(tempId, fileDict)
    })
  }
}

export const unbindFile = async (data: {
  file_id: string[]
  flyele_id: string
  flyele_type: 'task' | 'record'
}) => await http.post(`/disk/v2/storages/unbind`, data)

const bindFile = async (data: {
  file_id: ParamsFiles
  flyele_id: string
  flyele_type: 'task' | 'record'
}) => await http.post(`/disk/v2/storages/bind`, data)

async function changeFileState(
  id: number,
  fileDict: React.MutableRefObject<FileDict>,
  fileId?: string
) {
  const queryId = `#blot_${id}`,
    loadingDom = document.querySelector(`${queryId} .loading`),
    container = document.querySelector(`${queryId} span`),
    mainDom = document.querySelector(queryId)

  console.log('state change -->', loadingDom, container)

  if (!loadingDom || !container) return
  container.removeChild(loadingDom)

  // upload fail
  if (!fileId) {
    fileDict.current[id].state = 'fail'
    const failDom = document.createElement('div')
    failDom.innerText = '上传失败'
    failDom.classList.add('fail-dom')
    const retryDom = document.createElement('img')
    retryDom.src = './images/icons/retry.png'
    failDom.appendChild(retryDom)
    container.appendChild(failDom)
    return
  }

  // upload success
  try {
    // bind file
    const bindId = getBindId()
    if (bindId) {
      const [k, v] = bindId
      await bindFile({
        flyele_type: k,
        flyele_id: v,
        file_id: [
          {
            id: fileId,
            file_id: fileId,
            entry: getEntry(),
            origin: mainDom?.getAttribute('data-origin') as string,
          },
        ],
      })
    }

    const maskDom = container.querySelector('.mask')
    if (maskDom) {
      container.removeChild(maskDom)
    }

    fileDict.current[id] = {
      ...fileDict.current[id],
      state: 'success',
      id: fileId,
    }

    const wrapper = document.querySelector(queryId) as HTMLDivElement
    wrapper.style.color = 'white'
    wrapper.classList.add('blot-uploaded')
    wrapper.setAttribute('data-file', fileId)

    const bgDom = wrapper.querySelector('.bg-file') as HTMLImageElement | null
    if (bgDom) bgDom.src = bgDom.src.replace('/mask', '')
  } catch (e) {
    console.log('bind file error', e)
    Toast.fail('文件绑定失败')
  }
}
